import { ReactNode } from 'react';

import { DonationForm, SharedProps } from '../../types';
import Container from '../../UI/Container';
import Layout from '../../UI/Layout';
import { DonationFormLayout } from './DonationFormLayout';
import EditDonationFormSettingsForm from './EditDonationFormSettingsForm';

export interface DonationFormSettingsPageProps extends SharedProps {
  donationForm: DonationForm;
}

export default function DonationFormSettingsPage({
  donationForm,
  charity,
}: DonationFormSettingsPageProps) {
  return (
    <Container>
      <EditDonationFormSettingsForm
        donationForm={donationForm}
        charity={charity}
      />
    </Container>
  );
}

DonationFormSettingsPage.layout = (page: ReactNode) => <Layout><DonationFormLayout>{page}</DonationFormLayout></Layout>;
